import type { Clients, NPVRow } from "@/types/types";
import type { NPVSettings } from "@/types/types";
import { Dispatch } from "@reduxjs/toolkit";
import { RootState } from "..";
import { Titles, npvActions } from "./npv-slice";
import { NPV, NetPresentValue, NpvHelpers } from "@/pages/household/NPV/npv-utils";
import { calculateAge } from "@/pages/household/UP/up-utils";

export const SetNpv = (
  settings: NPVSettings,
  household: Clients,
  titles: Titles,
  grid: NPVRow[],
  npvHelpers: NpvHelpers[],
  npv: NPV[]
) => {
  return async (dispatch: Dispatch) => {
    dispatch(npvActions.setSettings(settings));
    dispatch(npvActions.setLocalHousehold(household));
    dispatch(npvActions.setTitles(titles));
    dispatch(npvActions.setGrid(grid));
    dispatch(npvActions.setNpvHelpers(npvHelpers));
    dispatch(npvActions.setNpv(npv));
    dispatch(CalcGrid(grid));
  };
};

export const CalcGrid = (uqGrid?: NPVRow[]) => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    const gridSet = getState().npv.gridSet;
    const settings = getState().npv.settings;
    const household = getState().household.household;
    const age1 = getState().household.age1;
    const age2 = getState().household.age2;
    const maxAgePrimary = age1 >= 90 ? 110 : 100;
    const maxAgeSecondary = age2 ? (age2 >= 90 ? 110 : 100) : maxAgePrimary;

    const maxAge = Math.max(maxAgePrimary, maxAgeSecondary);

    dispatch(npvActions.setMaxClientsAge(maxAge));
    dispatch(npvActions.setShouldStopAtAge(Math.min(maxAgePrimary, maxAgeSecondary)));

    const { newHelpers, npv: newNpv } = NetPresentValue.calcHelpers(settings, gridSet, age1, age2);
    const newGrid = NetPresentValue.createNpv(
      gridSet,
      newHelpers,
      newNpv,
      settings,
      household,
      uqGrid
    );
    dispatch(npvActions.setGrid(newGrid));
  };
};

export const Recalculate = () => {
  return async (dispatch: Dispatch, getState: () => RootState) => {
    const gridSet = getState().npv.gridSet;
    const settings = getState().npv.settings;
    const household = getState().npv.localHousehold;
    const age =
      household != null
        ? calculateAge(household?.primaryContact?.birthDate?.toString()!, 0).value
        : 0;

    const age2 = calculateAge(household?.secondaryContact?.birthDate?.toString(), 0)?.value;

    const { newHelpers, npv } = NetPresentValue.calcHelpers(settings, gridSet, age, age2);

    dispatch(npvActions.setNpv(npv));
    dispatch(npvActions.setNpvHelpers(newHelpers));
  };
};
